import { render, staticRenderFns } from "./form-error-message.component.vue?vue&type=template&id=28c7957e&scoped=true&"
import script from "./form-error-message.component.ts?vue&type=script&lang=ts&"
export * from "./form-error-message.component.ts?vue&type=script&lang=ts&"
import style0 from "./form-error-message.component.scss?vue&type=style&index=0&id=28c7957e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c7957e",
  null
  
)

export default component.exports